import React, { useState, useEffect } from 'react';
import SellerDetails from './SellerDetails';
import BuyerDetails from './BuyerDetails';
import ItemList from './ItemList';
import TaxDetails from './TaxDetails';
import InvoicePreview from './InvoicePreview';
import './gstbill.css';

function App() {
  const [invoiceData, setInvoiceData] = useState({
    seller: {
      name: '',
      address: '',
      mobile: '',
      email: '',
      gst: '',
      pan: '',
      image: ''
    },
    buyer: {
      name: '',
      address: '',
      pan: '',
      gst: ''
    },
    invoice: {
      number: '',
      date: new Date().toISOString().split('T')[0]
    },
    items: [{
      description: '',
      hsn: '',
      qty: 1,
      unit: 'Nos',
      rate: 0
    }],
    taxes: {
      cgst: 9,
      sgst: 9,
      igst: 0
    },
    companyName: ''
  });

  const [showPreview, setShowPreview] = useState(false);

  const handleInputChange = (section, field, value) => {
    setInvoiceData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...invoiceData.items];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: field === 'qty' || field === 'rate' ? parseFloat(value) || 0 : value
    };
    
    setInvoiceData(prev => ({
      ...prev,
      items: updatedItems
    }));
  };

  const addItem = () => {
    setInvoiceData(prev => ({
      ...prev,
      items: [
        ...prev.items,
        {
          description: '',
          hsn: '',
          qty: 1,
          unit: 'Nos',
          rate: 0
        }
      ]
    }));
  };

  const removeItem = (index) => {
    if (invoiceData.items.length <= 1) return;
    
    const updatedItems = [...invoiceData.items];
    updatedItems.splice(index, 1);
    
    setInvoiceData(prev => ({
      ...prev,
      items: updatedItems
    }));
  };

  const generateInvoice = () => {
    setShowPreview(true);
    window.scrollTo(0, 0);
  };

  const printInvoice = () => {
    window.print();
  };

  return (
    <div className="app-container">
      <div className={`form-container ${showPreview ? 'hidden' : ''}`}>
        <h2>GST Invoice Generator</h2>
        
        <SellerDetails 
          seller={invoiceData.seller} 
          onChange={handleInputChange} 
        />
        
        <hr />
        
        <div className="form-group">
          <label htmlFor="invoice-no">Invoice No:</label>
          <input 
            type="text" 
            id="invoice-no" 
            value={invoiceData.invoice.number}
            onChange={(e) => handleInputChange('invoice', 'number', e.target.value)}
            placeholder="Enter invoice number"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="invoice-date">Invoice Date:</label>
          <input 
            type="date" 
            id="invoice-date" 
            value={invoiceData.invoice.date}
            onChange={(e) => handleInputChange('invoice', 'date', e.target.value)}
          />
        </div>
        
        <hr />
        
        <BuyerDetails 
          buyer={invoiceData.buyer} 
          onChange={handleInputChange} 
        />
        
        <hr />
        
        <h3>Invoice Items</h3>
        <ItemList 
          items={invoiceData.items} 
          onChange={handleItemChange} 
          onRemove={removeItem}
        />
        <button id="add-item" onClick={addItem}>Add Another Item</button>
        
        <hr />
        
        <TaxDetails 
          taxes={invoiceData.taxes} 
          onChange={handleInputChange} 
        />
        
        <div className="form-group">
          <label htmlFor="company-name">Company Name (Footer):</label>
          <input 
            type="text" 
            id="company-name" 
            value={invoiceData.companyName}
            onChange={(e) => setInvoiceData(prev => ({...prev, companyName: e.target.value}))}
          />
        </div>
        
        <button id="generate-invoice" onClick={generateInvoice}>Generate Invoice</button>
      </div>
      
      {showPreview && (
        <>
          <InvoicePreview 
            data={invoiceData} 
          />
          <div className="form-container">
            <button id="print-invoice" onClick={printInvoice}>Print Invoice</button>
          </div>
        </>
      )}
    </div>
  );
}

export default App;